module.exports = __webpack_public_path__ + "static/img/KLT1550-FCM-370-73PBB-INT-1.jpg 18-04-13-789.a6141a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/KLT1550-FCM-370-73PBB-INT-1.jpg 18-04-13-789.jpg
// module id = pUee
// module chunks = 0